import * as React from 'react'

export const inputClass =
    'tw-w-full tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-background tw-px-3 tw-py-2 tw-text-sm tw-text-foreground'

export const skeletonBlock = 'tw-animate-pulse tw-rounded-lg tw-bg-muted tw-h-11'

export function Label({ children }) {
    return (
        <span className="tw-text-sm tw-font-medium tw-text-foreground">
            {children}
        </span>
    )
}

// The "+ / −" link that opens an optional part of the form.
export function DisclosureToggle({ open, onToggle, controls, testId, children }) {
    return (
        <button
            type="button"
            onClick={onToggle}
            aria-expanded={open}
            aria-controls={controls}
            data-testid={testId}
            className="tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0 tw-text-sm tw-text-primary tw-underline-offset-4 hover:tw-underline"
        >
            {open ? '− ' : '+ '}
            {children}
        </button>
    )
}
